import React, { useState ,useContext } from 'react'
import ModalPlayerStatics from './ModalPlayerStatics'
import  DataFetch from '../../Context/DataFetch'
import Language from '../../Context/Language'

export default function StaticLineUp({MatchData , lineUp}) {
  const [Homerenk , Homesetrenk] = useState("#5cabff")
  const [Homerenk2 , Homesetrenk2] = useState("#5cabff")
  const [Awayrenk , Awasetrenk] = useState("#3a446c")
  const [Awarenk2 , Awasetrenk2] = useState("#f9ef05")
  const [ModalPlayer , setModalPlayer] = useState(false)
  const [PlayerStaticData , setPlayerStaticData] = useState([])
  const [PlayerProfile , setPlayerProfile] = useState([])
  const [HomeTeamName , setHomeTeamName] = useState()
  const [HomeTeamId , setHomeTeamId] = useState()

  const {TeamPastStatic} = useContext(DataFetch)
  const datalang = useContext(Language)


  function handleClick(statistics , player , hometeam , homeTeamId) {
    setModalPlayer(true)
    setPlayerStaticData(statistics);
    setPlayerProfile(player)
    setHomeTeamName(hometeam)
    setHomeTeamId(homeTeamId)
  }


  const ModalCole = () => {
    setModalPlayer(false)
  }
  return (

 
     
      lineUp.length !== 0 ?
      <div className='StaticLineContainer'>
      {
        ModalPlayer ? <ModalPlayerStatics  HomeTeamId={HomeTeamId} HomeTeamName={HomeTeamName} MatchData={MatchData} PlayerStaticData={PlayerStaticData} PlayerProfile={PlayerProfile}   ModalCole={ModalCole}/> : ""
      }
      <div className='StaticContainerHome'>
        <div className='StaticLineUpHeader'>{datalang[sessionStorage.getItem("lang")].LineUp}</div>
        <div className='StaticLineUpCon'>
             {
               lineUp.filter(name => name.competitorId === MatchData.home_Team_Id ).sort((a, b) => a.player.jersey_number > b.player.jersey_number ? 1 : -1).map((filteredName , i) => (
                 filteredName.player.statistics4Player!== null && filteredName.player.statistics4Player.minutesPlayed > 0 ?
                  <div key={i}  onClick={()=>handleClick(filteredName.player.statistics4Player , filteredName.player  ,MatchData.home_Team_Name , MatchData.home_Team_Id )}  className='StaticLineUpPlayer'>
                  <div className='StaticLogoJerseyArea'>
                    <img src='/PlayerStatic.png' width={16} height={16}></img>
                  </div>
                  <div className='StaticJerseyNumberArea'>
                    <div className='StaticJerseyNumber'>{filteredName.player.jersey_number}</div>
                  </div>
                  <div className='StaticLineUpPlayerDiv'>{filteredName.player.name}</div>
                  </div>

                  :
                  ""
               ))
             }

        </div>
      </div>

      <hr id='staticLine'></hr>
      <div className='StaticContainerAway'>
      <div className='StaticLineUpHeader'>{datalang[sessionStorage.getItem("lang")].LineUp}</div>
      <div className='StaticLineUpCon'>

      {
               lineUp.filter(name => name.competitorId === MatchData.away_Team_Id).sort((a, b) => a.player.jersey_number > b.player.jersey_number ? 1 : -1).map((filteredName , i) => (
                filteredName.player.statistics4Player!== null &&  filteredName.player.statistics4Player.minutesPlayed > 0 ?
                <div key={i} onClick={()=>handleClick(filteredName.player.statistics4Player , filteredName.player  ,MatchData.away_Team_Name , MatchData.away_Team_Id )} className='StaticLineUpPlayer'>
                <div className='StaticLogoJerseyArea'>
                  <img src='/PlayerStatic.png' width={16} height={16}></img>
                </div>
                <div className='StaticJerseyNumberArea'>
                  <div className='StaticJerseyNumber'>{filteredName.player.jersey_number}</div>
                </div>
                <div className='StaticLineUpPlayerDiv'>{filteredName.player.name}</div>
                </div>
                :
                ""

               ))
             }

        </div>
      </div>
    </div>

       :
       <div className='DATANOTFOUNDDİV'>
       <div>{datalang[sessionStorage.getItem("lang")].Nodata}</div>
      </div>
  )
}
